import React, { useEffect, useState } from 'react';
import {
  Section,
  SettingToggle,
  SettingsSectionBox,
  SettingsSectionLabel,
  SettingsSectionRow,
} from '@views/Settings/components';
import { useDispatch, useSelector } from 'react-redux';
import { setUserMetadataFlag, updateDefaultReminderTime } from '@actions/user';
import { selectDefaultReminderTime, selectUserHasFlag } from '@reducers/user/metadata';
import styles from './Reminders.module.scss';
import { TimePicker } from '@components/DateTimePicker';
import { Time } from '@internationalized/date';

export default function Reminders() {
  const dispatch = useDispatch();
  const parsingDisabled = useSelector(selectUserHasFlag('disableNoteReminderParsing'));
  const { hour, minute } = useSelector(selectDefaultReminderTime);
  const [defaultReminderTime, setDefaultReminderTime] = useState<Time>(new Time(hour, minute));

  useEffect(() => {
    if (
      defaultReminderTime &&
      (defaultReminderTime?.hour !== hour || defaultReminderTime?.minute !== minute)
    ) {
      dispatch(updateDefaultReminderTime(defaultReminderTime));
    }
  }, [defaultReminderTime, hour, minute]);

  return (
    <Section>
      <SettingsSectionLabel tooltip={undefined}>Reminders</SettingsSectionLabel>
      <SettingsSectionBox>
        <SettingsSectionRow className={styles.disableReminderParsingSection}>
          <SettingToggle
            title="Disable reminder auto-detection"
            checked={parsingDisabled}
            name="disable_note_reminder_parsing"
            onChange={() =>
              dispatch(setUserMetadataFlag('disableNoteReminderParsing', !parsingDisabled))
            }
          />
          <p>
            Disable Clay's default behavior of automatically detecting reminder dates while you type
            a note.
          </p>
        </SettingsSectionRow>
        <div className={styles.defaultReminderTimeSection}>
          Default reminders time
          <TimePicker
            value={defaultReminderTime}
            onChange={(time) => setDefaultReminderTime(time)}
          />
          <p>
            The reminder date picker will default to the time you select. If enabled, reminders
            automatically detected in notes will also default to this time unless a different time
            is specified.
          </p>
        </div>
      </SettingsSectionBox>
    </Section>
  );
}
